import { render } from "./AdminInquiry.vue?vue&type=template&id=40f942a2"
import script from "./AdminInquiry.vue?vue&type=script&lang=js"
export * from "./AdminInquiry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__